<template>
  <div class="all-prices__header">
    <div class="f gap16 w-100 all-prices__title-wrapper">
      <p class="all-prices__title f gap8">
        <span>{{ title }}</span>
        <img
          v-if="showImg"
          :alt="selectedMarket?.market?.market_full_name"
          :src="getImageFromProxy(`${imagesUrl}${selectedMarket?.market?.logo_name}`, '50:50')"
          height="20"
          width="20"
        >
      </p>
      <span
        class="all-prices__updated-time smh"
      >
        {{ t('last_update_at', { date: getFormattedDate(updatedAt || "") }) }}
      </span>

      <button
        class="btn modal_close smsh"
        @click="closeModal(ModalIds.COMPARISON_MARKETS_STATS)"
      >
        <i class="i-times" />
      </button>
    </div>
    <span
      class="all-prices__updated-time smsh"
    >
      {{ t('last_update_at', { date: getFormattedDate(updatedAt || "") }) }}
    </span>

    <div class="stats-wrapper">
      <div class="sales all-prices__header-stats">
        <div class="all-prices__header-item">
          <p class="item-label">
            {{ t("sales") }}
          </p>
          <p class="item-value">
            {{ sales?.toLocaleString("ru-RU") }}
          </p>
        </div>
        <div class="line" />
        <div class="all-prices__header-item">
          <p class="item-label">
            {{ t("median") }}
          </p>
          <UiPrice
            :price="medianPrice || 0"
            class="item-value"
          />
        </div>
        <div class="all-prices__header-item">
          <p class="item-label">
            {{ t("average") }}
          </p>
          <UiPrice
            :price="averagePrice || 0"
            class="item-value"
          />
        </div>
        <div class="line" />
        <div class="all-prices__header-item">
          <p class="item-label">
            {{ t("rec") }}
          </p>
          <UiPrice
            :price="recPrice || 0"
            class="item-value"
          />
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ComparisonPriceInfo } from '~/graphql/generated/schema-types';
import { useRuntimeConfig } from '#imports';
import { useI18n } from 'vue-i18n';
import UiPrice from '~/components/ui/Price.vue';
import { useModalStore } from '~/store/modal';
import { ModalIds } from '~/types/Modals';
import { getFormattedDate } from '~/utils/date-utils';
import { getImageFromProxy } from '~/utils/get-image-url';

defineProps<{
  title: string
  updatedAt?: string
  sales?: number
  medianPrice?: number
  averagePrice?: number
  recPrice?: number
  selectedMarket?: ComparisonPriceInfo
  chartMarket?: string
  showImg: boolean
}>();

const config = useRuntimeConfig();
const imagesUrl = config.public.imagesUrl;
const { t } = useI18n();
const { closeModal } = useModalStore();
</script>

<style lang="scss" scoped>
.all-prices {
  &__header {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: var(--surfaces-on-surface);
  }

  &__updated-time {
    color: #636e84;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }

  &__header-stats {
    display: grid;
    grid-template-columns: 4fr 42px 4fr;
  }

  &__header-item {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    align-items: center;
  }

  .item-label {
    color: var(--surfaces-on-surface-variable);
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }

  .item-value {
    color: var(--white);
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
  }

  .line {
    width: 2px;
    height: 16px;
    background: var(--accent-on-surface);
    justify-self: center;
    align-self: center;
  }

  .stats-wrapper {
    display: grid;
    grid-template-columns: 5fr 3fr;
    margin-bottom: 24px;
  }

  .smh {
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 470px) {
      display: none;
    }
  }

  .smsh {
    display: none;
    @media screen and (max-width: 470px) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media screen and (max-width: 470px) {
    &__title-wrapper {
      border-bottom: 1px solid var(--surfaces-outline);
      width: 100%;
      padding-bottom: 16px;
    }
    .stats-wrapper {
      display: flex;
      flex-direction: column-reverse;
    }
  }
}
</style>
